// // tools
// import { useState } from "react";
// import { Link, NavLink } from "react-router-dom";
// import { useTranslation } from "react-i18next";

// //icons
// import { FiChevronDown } from "react-icons/fi";

// // Images
// import logo from "../../assets/logo/KiutLogo.png";

// // Components
// import HamburgerBtn from "./hamburger-btn/HamburgerBtn";

// // SCSS
// import "./Header.scss";
// import LanguageBtn from "./language-btn/LanguageBtn";
// import MobileNav from "./mobile-nav/MobileNav";

// const Header = () => {
//   const { t } = useTranslation();
//   const [aboutListActive, setAboutListActive] = useState(false);
//   const [programListActive, setProgramListActive] = useState(false);
//   const [submissionListActive, setSubmissionActive] = useState(false);
//   const [publicsListActive, setPublicsListActive] = useState(false);
//   const [isNavActive, setNavActive] = useState(false);

//   document.body.style.overflow = isNavActive ? "hidden" : "auto";

//   return (
//     <header className="header">
//       <div className="container">
//         <div className="header-logo">
//           <Link to="/">
//             <img src={logo} alt="Site logo" />
//           </Link>
//         </div>
//         <nav className="header-nav">
//           <ul className="nav-list">
//             <li className="nav-list__item">
//               <NavLink
//                 className={({ isActive }) =>
//                   isActive ? "nav__link active" : "nav__link"
//                 }
//                 to="/"
//               >
//                 {t("home")}
//               </NavLink>
//             </li>
//             <li
//               onMouseEnter={() => {
//                 setAboutListActive(true);
//               }}
//               onMouseLeave={() => {
//                 setAboutListActive(false);
//               }}
//               className="nav-list__item"
//             >
//               <Link className="nav__link" to="#">
//                 {t("confere")}
//                 <FiChevronDown className="down-arrow" />
//               </Link>
//               <ul
//                 style={
//                   aboutListActive ? { display: "block" } : { display: "none" }
//                 }
//                 className="nav__sub-list nav-link__sub-list"
//                 onClick={() => {
//                   setAboutListActive(false);
//                 }}
//               >
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="/about">{t("about")}</Link>
//                 </li>
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="/detail/modern-trends-in-the-development-of-chemical-and-biological-technologies">
//                     Artificial Intelligence in Medicine 
//                   </Link>
//                 </li>
//                  <li className="sub-list__item nav-sub__list-item">
//                   <Link to="/detail/new1">CLIMATE </Link>
//                 </li> 
//                  <li className="sub-list__item nav-sub__list-item">
//                   <Link to="/detail/new2">
//                   Modern Innovative Solutions
//                   </Link>
//                 </li> 
//               </ul>
//             </li>
//             <li
//               onMouseEnter={() => {
//                 setProgramListActive(true);
//               }}
//               onMouseLeave={() => {
//                 setProgramListActive(false);
//               }}
//               className="nav-list__item"
//             >
//               <Link className="nav__link" to="#">
//                 {t("Programs")}
//                 <FiChevronDown className="down-arrow" />
//               </Link>
//               <ul
//                 style={
//                   programListActive ? { display: "block" } : { display: "none" }
//                 }
//                 className="nav__sub-list nav-link__sub-list"
//                 onClick={() => {
//                   setProgramListActive(false);
//                 }}
//               >
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="requirements">{t("requirements")}</Link>
//                 </li>
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="/committee/organizing">{t("organiza")}</Link>
//                 </li>
//               </ul>
//             </li>
//             <li
//               onMouseEnter={() => {
//                 setSubmissionActive(true);
//               }}
//               onMouseLeave={() => {
//                 setSubmissionActive(false);
//               }}
//               className="nav-list__item"
//             >
//               <Link className="nav__link" to="#">
//                 {t("Submission")}
//                 <FiChevronDown className="down-arrow" />
//               </Link>
//               <ul
//                 style={
//                   submissionListActive
//                     ? { display: "block" }
//                     : { display: "none" }
//                 }
//                 className="nav__sub-list nav-link__sub-list"
//                 onClick={() => {
//                   setSubmissionActive(false);
//                 }}
//               >
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="submission">Artificial Intelligence in Medicine </Link>
//                 </li>
//                  <li className="sub-list__item nav-sub__list-item">
//                   <Link to="submissionNW1">CLIMATE</Link>
//                 </li>
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="submissionNW2">
//                   Modern Innovative Solutions
//                   </Link>
//                 </li> 
//               </ul>
//             </li>
//             <li
//               onMouseEnter={() => {
//                 setPublicsListActive(true);
//               }}
//               onMouseLeave={() => {
//                 setPublicsListActive(false);
//               }}
//               className="nav-list__item"
//             >
//               <Link className="nav__link" to="#">
//                 {t("publications")}
//                 <FiChevronDown className="down-arrow" />
//               </Link>
//               <ul
//                 style={
//                   publicsListActive ? { display: "block" } : { display: "none" }
//                 }
//                 className="nav__sub-list nav-link__sub-list"
//                 onClick={() => {
//                   setPublicsListActive(false);
//                 }}
//               >
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="publications/tipf">TIPF-2023</Link>
//                 </li>
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="publications/namangan">Namangan-2023</Link>
//                 </li>
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="publications/2024_1">Dietary history</Link>
//                 </li>
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="publications/2024_2">Issues of language and translation- ILT- 2024</Link>
//                 </li>
//                 <li className="sub-list__item nav-sub__list-item">
//                   <Link to="publications/2024_3">Namangan-2024</Link>
//                 </li>
//               </ul>
//             </li>
//           </ul>
//         </nav>
//         <div className="header__right">
//           <LanguageBtn />
//           <HamburgerBtn isNavActive={isNavActive} setNavActive={setNavActive} />
//           <MobileNav isNavActive={isNavActive} setNavActive={setNavActive} />
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;

// Header.jsx

// tools
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

// icons
import { FiChevronDown } from "react-icons/fi";

// images
import logo from "../../assets/logo/KiutLogo.png";

// Components
import HamburgerBtn from "./hamburger-btn/HamburgerBtn";
import LanguageBtn from "./language-btn/LanguageBtn";
import MobileNav from "./mobile-nav/MobileNav";

// SCSS
import "./Header.scss";

const Header = () => {
  const { t } = useTranslation();

  const [aboutListActive, setAboutListActive] = useState(false);
  const [programListActive, setProgramListActive] = useState(false);
  const [submissionListActive, setSubmissionActive] = useState(false);
  // publications dropdown olib tashlangani uchun publikatsiya uchun state kerak emas
  const [isNavActive, setNavActive] = useState(false);

  // Mobil nav ochilganda page scrollni o‘chirib qo‘yish
  document.body.style.overflow = isNavActive ? "hidden" : "auto";

  return (
    <header className="header">
      <div className="container">
        {/* Logo bo‘limi */}
        <div className="header-logo">
          <Link to="/">
            <img src={logo} alt="Site logo" />
          </Link>
        </div>

        {/* Asosiy navigatsiya */}
        <nav className="header-nav">
          <ul className="nav-list">
            {/* Home */}
            <li className="nav-list__item">
              <NavLink
                className={({ isActive }) =>
                  isActive ? "nav__link active" : "nav__link"
                }
                to="/"
              >
                {t("home")}
              </NavLink>
            </li>

            {/* Conferences (dropdown misoli) */}
            <li
              onMouseEnter={() => setAboutListActive(true)}
              onMouseLeave={() => setAboutListActive(false)}
              className="nav-list__item"
            >
              <Link className="nav__link" to="#">
                {t("confere")} <FiChevronDown className="down-arrow" />
              </Link>
              <ul
                style={aboutListActive ? { display: "block" } : { display: "none" }}
                className="nav__sub-list nav-link__sub-list"
                onClick={() => setAboutListActive(false)}
              >
                <li className="sub-list__item nav-sub__list-item">
                  <Link to="/about">{t("about")}</Link>
                </li>
                <li className="sub-list__item nav-sub__list-item">
                  <Link to="/detail/modern-trends-in-the-development-of-chemical-and-biological-technologies">
                    Artificial Intelligence in Medicine
                  </Link>
                </li>
                <li className="sub-list__item nav-sub__list-item">
                  <Link to="/detail/new1">CLIMATE</Link>
                </li>
                <li className="sub-list__item nav-sub__list-item">
                  <Link to="/detail/new2">Samarkand Conference</Link>
                </li>
              </ul>
            </li>

            {/* Programs (dropdown misoli) */}
            <li
              onMouseEnter={() => setProgramListActive(true)}
              onMouseLeave={() => setProgramListActive(false)}
              className="nav-list__item"
            >
              <Link className="nav__link" to="#">
                {t("Programs")} <FiChevronDown className="down-arrow" />
              </Link>
              <ul
                style={programListActive ? { display: "block" } : { display: "none" }}
                className="nav__sub-list nav-link__sub-list"
                onClick={() => setProgramListActive(false)}
              >
                <li className="sub-list__item nav-sub__list-item">
                  <Link to="requirements">{t("requirements")}</Link>
                </li>
                <li className="sub-list__item nav-sub__list-item">
                  <Link to="/committee/organizing">{t("organiza")}</Link>
                </li>
              </ul>
            </li>

            {/* Submission (dropdown misoli) */}
            <li
              onMouseEnter={() => setSubmissionActive(true)}
              onMouseLeave={() => setSubmissionActive(false)}
              className="nav-list__item"
            >
              <Link className="nav__link" to="#">
                {t("Submission")} <FiChevronDown className="down-arrow" />
              </Link>
              <ul
                style={submissionListActive ? { display: "block" } : { display: "none" }}
                className="nav__sub-list nav-link__sub-list"
                onClick={() => setSubmissionActive(false)}
              >
                <li className="sub-list__item nav-sub__list-item">
                  <Link to="submission">Artificial Intelligence in Medicine</Link>
                </li>
                <li className="sub-list__item nav-sub__list-item">
                  <Link to="submissionNW1">CLIMATE</Link>
                </li>
                <li className="sub-list__item nav-sub__list-item">
                  <Link to="submissionNW2">Samarkand Conference</Link>
                </li>
              </ul>
            </li>

            {/* Publications (to‘liq linkga o‘zgartirildi, sub-menu olib tashlandi) */}
            <li className="nav-list__item">
              <a
                className="nav__link"
                href="https://publication.kiut.uz"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("publications")}
              </a>
            </li>
          </ul>
        </nav>

        {/* Header o‘ng tomoni: til va hamburger */}
        <div className="header__right">
          <LanguageBtn />
          <HamburgerBtn isNavActive={isNavActive} setNavActive={setNavActive} />
          <MobileNav isNavActive={isNavActive} setNavActive={setNavActive} />
        </div>
      </div>
    </header>
  );
};

export default Header;
